<section class="container-wrapper questionnaire-checkbox">
    <mat-checkbox [formControl]="checkboxControl()">
      {{ label() || '' | translate }}
      @if(infoTooltip()){
        <mat-icon
          svgIcon="icon_info_24"
          [appTooltip]="infoTooltip()"
          [position]="TooltipPosition.BELOW"
          [tooltipWidth]="tooltipWidth()"
        />
      }
    </mat-checkbox>
</section>
